{
  "age_over_time": "Средний возраст по периодам",
  "all_balances": "Все остатки",
  "average_turnover": "Средняя текучка",
  "by_departments": "по отделам",
  "by_divisions": "по подразделениям",
  "by_job_profiles": "по должностным профилям",
  "by_job_roles": "по ролям",
  "by_leave_types": "по типам ухода",
  "by_locations": "по локациям",
  "by_termination_reasons": "по причинам увольнения",
  "dimension_age_group": "Возрастная группа",
  "ending_balance": "Конечный баланс",
  "gross": "До удержаний",
  "growth_over_time": "Рост по периодам",
  "headcount_for_period": "Численность за период",
  "headcount_over_time": "Численность по периодам",
  "headcount_report_description": "Отслеживайте текущую численность и распределение по отделам",
  "headcount_report_growth_chart_tooltip": "Показывает, насколько быстро организация росла или сокращалась относительно предыдущего интервала. Положительные значения означают рост команды, отрицательные - что увольнений было больше, чем новых наймов.",
  "headcount_report_headcount_chart_tooltip": "Показывает, как менялась численность сотрудников за выбранный период. Каждая точка отражает количество сотрудников на конец интервала, поэтому график помогает увидеть общий тренд размера команды.",
  "headcount_report_joiners_leavers_chart_tooltip": "Сравнивает сотрудников, которые пришли в компанию, с сотрудниками, которые ушли, по каждому интервалу. Так проще увидеть, покрывает ли найм потери команды со временем.",
  "headcount_report_manager_ratio_chart_tooltip": "Показывает соотношение руководителей и сотрудников во времени. Руководителями считаются сотрудники, у которых есть хотя бы один прямой подчинённый, поэтому график помогает оценить управленческую нагрузку. Руководитель с подчинёнными в нескольких отделах учитывается в каждом бакете.",
  "headcount_report_managers_chart_tooltip": "Показывает, сколько сотрудников выступали руководителями в каждом интервале. Сотрудник попадает в этот показатель, если на него ссылается хотя бы один подчинённый, что помогает отслеживать размер управленческого слоя. Руководитель с подчинёнными в нескольких отделах учитывается в каждом бакете.",
  "headcount_report_people_future": "\nбудет в вашей команде\nк",
  "headcount_report_people_now": "\nв вашей команде\nсейчас",
  "headcount_report_people_were": "\nбыло в вашей команде\n",
  "headcount_report_title": "Численность персонала",
  "headcount_report_turnover_chart_tooltip": "Показывает долю сотрудников, которые покинули компанию в каждом интервале. Этот график помогает заметить периоды с повышенной текучкой и понять, где стоит искать причины уходов.",
  "include_all_active_description": "Включить архивные и неактивные вакансии, в которых были изменения по этапам в выбранный период.",
  "include_all_active_title": "Показать неактивные вакансии с изменениями этапов",
  "include_inactive_jobs_description": "Показать все активные вакансии, даже если в выбранный период не было изменений по этапам",
  "include_inactive_jobs_title": "Показать вакансии без изменений по этапам",
  "joiners": "Новые сотрудники",
  "joiners_and_leavers": "Принятые и уволенные",
  "last_salary_updated": "Последнее обновление зарплаты",
  "last_updated": "Последнее обновление",
  "leavers": "Уволившиеся",
  "lifetime_growth": "Рост за всё время",
  "manager_ratio_for_period": "Руководителей на сотрудника за период",
  "manager_ratio_over_time": "Руководителей на сотрудника по периодам",
  "managers_for_period": "Руководители за период",
  "managers_over_time": "Руководители по периодам",
  "metric_age": "Средний возраст",
  "metric_age_description": "Средний возраст сотрудников за выбранный период с учётом фильтров",
  "metric_attrition": "Отток",
  "metric_attrition_description": "Добровольно уволившиеся сотрудники как доля от средней численности за выбранный период",
  "metric_average_salary": "Средняя зарплата",
  "metric_growth": "Рост",
  "metric_headcount": "Численность",
  "metric_joiners": "Принятые",
  "metric_leavers": "Уволенные",
  "metric_manager_ratio": "Руководителей на сотрудника",
  "metric_managers": "Руководители",
  "metric_median_salary": "Медианная зарплата",
  "metric_retention": "Удержание",
  "metric_retention_description": "Доля сотрудников, которые остались в компании с начала до конца выбранного периода",
  "metric_tenure": "Средний стаж",
  "metric_tenure_chart_description": "Среднее общее время работы сотрудников в компании, отображается в месяцах",
  "metric_tenure_description": "Среднее общее время работы сотрудников в компании, отображается в годах",
  "metric_total_bonus": "Сумма бонусов",
  "metric_total_payroll": "Фонд оплаты труда",
  "metric_total_cost": "Полная стоимость для компании",
  "metric_employer_contributions": "Взносы работодателя",
  "metric_turnover": "Текучесть",
  "metric_turnover_description": "Все добровольные и недобровольные увольнения как доля от средней численности за выбранный период",
  "my_reports": "Мои отчёты",
  "net": "К выплате",
  "over_time": "по периодам",
  "people_analytics_aggregation_avg": "Среднее",
  "people_analytics_aggregation_count": "Количество",
  "people_analytics_aggregation_count_distinct": "Уникальных",
  "people_analytics_aggregation_max": "Максимум",
  "people_analytics_aggregation_median": "Медиана",
  "people_analytics_aggregation_min": "Минимум",
  "people_analytics_aggregation_sum": "Сумма",
  "people_analytics_aggregation_values": "Значения",
  "people_analytics_chart_needs_group": "Выберите группировку, чтобы построить график",
  "people_analytics_chart_needs_series": "Выберите хотя бы одну числовую колонку для графика",
  "people_analytics_chart_unavailable_employee": "Недоступно при группировке по сотруднику",
  "people_analytics_employee_report": "Отчёт по сотрудникам",
  "people_analytics_visualisation_bar": "Столбчатый график",
  "people_analytics_visualisation_line": "Линейный график",
  "people_analytics_date_grain_day": "По дням",
  "people_analytics_date_grain_month": "По месяцам",
  "people_analytics_date_grain_none": "Точные даты",
  "people_analytics_date_grain_quarter": "По кварталам",
  "people_analytics_date_grain_week": "По неделям",
  "people_analytics_date_grain_year": "По годам",
  "people_analytics_group_by_employee": "Сотрудник",
  "people_analytics_group_by_none": "Без группировки",
  "people_analytics_group_by_placeholder": "Выберите поле...",
  "people_analytics_group_people_by": "Группировать по",
  "people_analytics_group_empty": "Не задано",
  "people_analytics_period": "За период",
  "people_analytics_scope_current": "На сегодня",
  "people_analytics_scope_as_of": "На дату",
  "people_analytics_scope_as_of_desc": "Значения метрик на выбранную дату",
  "people_analytics_scope_period": "События за период",
  "people_analytics_scope_period_desc": "Изменения метрик за выбранный период",
  "people_analytics_scope_choose_period": "Выберите период",
  "people_analytics_scope_choose_date": "Выберите дату",
  "people_analytics_choose_field": "Выбрать поле",
  "people_analytics_empty_group_title": "Выберите, как сгруппировать людей",
  "people_analytics_empty_group_description": "Начните с поля — например, отдел, локация или тип занятости.",
  "people_analytics_add_metric": "Добавить метрику",
  "people_analytics_filter": "Фильтр",
  "people_analytics_filter_by": "Фильтр по «{name}»",
  "people_analytics_filter_search": "Поиск поля",
  "people_analytics_configure": "Настройка",
  "people_analytics_save_blocked_values": "Агрегацию «Значения» можно сохранить только в таблице. Переключите визуализацию на таблицу или выберите для этих колонок другую агрегацию.",
  "people_analytics_show_metrics": "Метрики",
  "people_analytics_sort": "Сортировка",
  "people_analytics_sort_asc": "По возрастанию",
  "people_analytics_sort_desc": "По убыванию",
  "people_analytics_sort_none": "Без сортировки",
  "people_analytics_new_report": "Новый отчёт",
  "people_analytics_description": "Исследуйте и группируйте данные сотрудников по любому измерению",
  "people_analytics_report_title": "Отчёт: {group}",
  "people_analytics_title": "Аналитика по сотрудникам",
  "people_analytics_visualisation": "Визуализация",
  "people_analytics_total_employees": "Всего сотрудников",
  "people_analytics_row_total": "Итого",
  "people_analytics_warning_history_access_denied": "Нет доступа к истории — показана актуальная строка",
  "people_analytics_warning_metric_requires_period": "Метрика считается только в срезе «за период»",
  "people_analytics_cache_built_at": "Данные на {date}",
  "people_analytics_cache_live": "Данные считаются на лету",
  "people_analytics_cache_rebuild": "Обновить сейчас",
  "people_analytics_save_as": "Сохранить как",
  "people_analytics_save_as_new": "Сохранить как новый...",
  "people_analytics_save_widget": "Сохранить как виджет",
  "people_analytics_widget_saved": "Виджет сохранён",
  "people_analytics_widget_title": "Название виджета",
  "people_analytics_widget_updated": "Отчёт обновлён",
  "people_analytics_rename": "Переименовать",
  "people_analytics_rename_report": "Переименовать отчёт",
  "people_analytics_delete_report": "Удалить отчёт",
  "people_analytics_delete_confirm": "Удалить отчёт «{title}»? Действие необратимо.",
  "people_analytics_warning_no_history": "Нет истории — показано текущее значение",
  "people_analytics_warning_missing_fx_rate": "Часть выплат не учтена: нет курса валюты",
  "people_analytics_warning_missing_currency": "Часть сумм не учтена: не указана валюта",
  "period_growth": "Рост за период",
  "permissions_headcount_report_description": "Просмотр отчета по численности персонала",
  "permissions_people_analytics_report_description": "Просмотр отчёта по сотрудникам",
  "permissions_retention_report_description": "Просмотр отчета по удержанию",
  "permissions_salary_report_description": "Просмотр отчета по зарплатам",
  "permissions_time_off_balance_report": "Просмотр отчета о балансах времени отдыха для команды",
  "permissions_time_off_history_report": "Просмотр истории отсутствий для команды",
  "retention_over_time": "Удержание по периодам",
  "retention_report_description": "Отслеживайте удержание, текучесть, отток и стаж сотрудников",
  "retention_report_title": "Удержание",
  "salary_allocation_by_days": "Переводы — по дням",
  "salary_allocation_period_end": "Переводы — на конец периода",
  "salary_average": "Средняя {salary_type}",
  "salary_average_changes_gross": "Среднее изменение оклада",
  "salary_average_changes_net": "Среднее изменение суммы к выплате",
  "salary_average_gross": "Средний оклад",
  "salary_average_net": "Средняя сумма к выплате",
  "salary_by_departments": "По отделам",
  "salary_by_divisions": "По подразделениям",
  "salary_by_job_profiles": "По должностным профилям",
  "salary_by_job_roles": "По ролям",
  "salary_by_locations": "По локациям",
  "salary_changes": "{salary_type} изменения",
  "salary_changes_gross": "Изменение оклада",
  "salary_changes_net": "Изменение суммы к выплате",
  "salary_gross": "Оклад (до удержаний)",
  "salary_median": "Медианная {salary_type}",
  "salary_median_gross": "Медианный оклад",
  "salary_median_net": "Медианная сумма к выплате",
  "salary_net": "К выплате",
  "salary_report_description": "Отслеживайте и анализируйте изменения зарплат сотрудников",
  "salary_report_title": "Зарплаты",
  "split_by": "Разбить по",
  "tenure_over_time": "Средний стаж по периодам",
  "time_off_balance_report_description": "Отслеживайте доступные дни отсутствия, больничные и другие отгулы для команды",
  "time_off_history_report_description": "Отслеживайте запросы и утверждения на отсутствие для команды",
  "time_off_history_report_title": "История отсутствий",
  "tooltip_current_period": "В конце периода",
  "tooltip_previous_period": "В начале периода",
  "total_gross_pay": "Сумма выплат за период (до удержаний)",
  "total_headcount": "Общая численность",
  "total_net_pay": "Сумма выплат за период",
  "~": "~"
}
